var domain = 'https://ruvents.com/';

export var RUVWidget = new function() {
    function RUVWidget(container) {
        this.registerStyle();

        this.baseUrl = domain + 'widget/main/index';
        this.url = document.location;
        this.container = container;
        this.event = container.getAttribute('data-event');
        this.lang = container.getAttribute('data-lang');

        this.preloader = document.createElement('div');
        this.preloader.setAttribute(
            'style',
            "display:block;position:absolute;left:50%;margin-left:-50px;height:50px;width:50px;background: url('//runet-id.com/images/api/widget-preloder.gif') no-repeat center center;"
        );
        this.container.appendChild(this.preloader);

        this.initSocket();
    }

    RUVWidget.prototype.registerStyle = function() {
        var style = document.createElement('style');
        style.innerText =
            '.ruv-widget > iframe {visibility:hidden;} .ruv-widget iframe {overflow:hidden;}';
        document.getElementsByTagName('body')[0].insertBefore(style, null);
    };

    RUVWidget.prototype.initSocket = function() {
        var self = this;
        var socket = new easyXDM.Socket({
            remote: self.getUrl(),
            container: self.container,
            onMessage: function(message, origin) {
                self.preloader.style.display = 'none';
                var iframe = this.container.getElementsByTagName('iframe')[0];
                iframe.scrolling = 'no';
                iframe.style.visibility = 'visible';
                iframe.style.width = '100%';
                iframe.style.height = 4 + parseInt(message) + 'px';
            },
        });
    };

    RUVWidget.prototype.getUrl = function() {
        var self = this;
        var action = self.action != null ? self.action : 'index';

        var url =
            '/widget/event-register/' + action + '?' + 'event=' + self.event;
        if (self.lang) {
            url += '&lang=' + self.lang + '&langnocookie=1';
        }

        for (var i = 0; i < this.container.attributes.length; i++) {
            var attr = this.container.attributes.item(i);
            if (attr.nodeName.indexOf('data-param-') != -1) {
                url +=
                    '&' +
                    attr.nodeName.substr(5) +
                    '=' +
                    encodeURIComponent(attr.nodeValue);
            }
        }

        url = self.baseUrl + '?url=' + encodeURIComponent(url);
        return url;
    };
    return RUVWidget;
}();



// WEBPACK FOOTER //
// ./src/templates/ruvents.js